import { createContext } from "react";

const PuestosContext = createContext();

export default PuestosContext;
